import { BranchRecord } from './types'

export const pickDefaultBranchId = (
	branches: Pick<BranchRecord, 'id' | 'status'>[],
	currentId: string | null,
): string | null => {
	const selectable = branches.filter((branch) => branch.status !== 'DELETED')
	if (currentId && selectable.some((branch) => branch.id === currentId)) {
		return currentId
	}
	return selectable[1]?.id ?? selectable[0]?.id ?? null
}

/** Parent only. Main and a missing or deleted parent have no default comparison. */
export const parentCompareTarget = (
	branch: Pick<BranchRecord, 'sourceBranchId'>,
	branches: Pick<BranchRecord, 'id' | 'status'>[],
): string | null => {
	if (!branch.sourceBranchId) return null
	const parent = branches.find((item) => item.id === branch.sourceBranchId)
	if (!parent || parent.status === 'DELETED') return null
	return parent.id
}

export const pickCompareTarget = (
	branch: Pick<BranchRecord, 'id' | 'sourceBranchId'>,
	branches: Pick<BranchRecord, 'id' | 'sourceBranchId' | 'status'>[],
): string | null => {
	const selectable = branches.filter(
		(item) => item.status !== 'DELETED' && item.id !== branch.id,
	)
	return (
		selectable.find((item) => item.id === branch.sourceBranchId)?.id ??
		selectable.find((item) => !item.sourceBranchId)?.id ??
		selectable[0]?.id ??
		null
	)
}
